import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomerFeaturesService } from './customer-features.service';

export const customerFeaturesGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const customerFeaturesService = inject(CustomerFeaturesService);
  const feature = route.data['feature'];

  if (customerFeaturesService.hasFeature(feature)) {
    return true;
  } else {
    router.navigate(['/']);
    return false;
  }
};
